import styled from 'styled-components';

export const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  button {
    &:first-child {
      margin-right: 10px;
    }
  }
`;
export const Wrap = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 16px;

  @media screen and (max-width: 550px) {
    flex-direction: column;
  }
`;

export const InputNoForm = styled.input`
  width: 100%;
  height: 48px;
  border-radius: 4px;
  border: 1px solid #d6d6d6;
  padding: 16px;
  font-family: 'InterSemiBold', sans-serif;
  font-size: 16px;
  line-height: 20px;
  color: #828282;
  background-color: transparent;
  /* box-shadow: 0 3px 12px rgba(0, 0, 0, 0.075); */
  &[type='number'] {
    -moz-appearance: textfield;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
    }
  }

  &[disabled] {
    background-color: #ededed;
    &::placeholder {
      content: '';
    }
  }

  &::-webkit-input-placeholder {
    opacity: 1;
  }

  &:-ms-input-placeholder {
    opacity: 1;
  }

  &:-moz-placeholder {
    opacity: 1;
  }

  &::-moz-placeholder {
    opacity: 1;
  }
`;

export const MainLoading = styled.div`
  display: ${({ loading }) => (loading ? 'flex' : 'none')};
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  top: 0;

  .icon-spin {
    animation: iconSpin 1s infinite linear;
  }

  @keyframes iconSpin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }

  h3 {
    font-family: 'InterBold', sans-serif;
    font-size: 32px;
    line-height: 36px;
    color: #ffffff;
    margin-right: 12px;
  }
`;
